export default __webpack_public_path__ + "static/media/Fuel Management.c6fe0f69.svg";